import { useRef } from 'react';
import { telemetry } from './telemetry';
import { useRafLoop } from './useRafLoop';
import { useGameStore } from '../state/store';

interface HudProps {
  onPause: () => void;
}

const GEAR_LABEL: Record<'V' | 'N' | 'R', string> = { V: 'V', N: 'N', R: 'R' };

/**
 * Tacho und Gang. Werte kommen aus dem geteilten Telemetrie-Objekt und
 * werden direkt in den DOM geschrieben - kein React-Rerender pro Frame.
 */
export function Hud({ onPause }: HudProps): JSX.Element {
  const speedRef = useRef<HTMLElement>(null);
  const gearRef = useRef<HTMLElement>(null);
  const lastSpeed = useRef(-1);
  const lastGear = useRef('');
  const missionTitleRef = useRef<HTMLElement>(null);
  const missionHintRef = useRef<HTMLElement>(null);
  const missionProgressRef = useRef<HTMLDivElement>(null);
  const coins = useGameStore((s) => s.coins);
  const stars = useGameStore((s) => s.stars);
  const gameMode = useGameStore((s) => s.gameMode);

  useRafLoop(() => {
    const kmh = Math.round(telemetry.speedKmh);
    if (kmh !== lastSpeed.current && speedRef.current) {
      lastSpeed.current = kmh;
      speedRef.current.textContent = String(kmh);
    }
    const gear = GEAR_LABEL[telemetry.gear];
    if (gear !== lastGear.current && gearRef.current) {
      lastGear.current = gear;
      gearRef.current.textContent = gear;
    }
    if (missionTitleRef.current) missionTitleRef.current.textContent = telemetry.missionTitle || 'FREIE FAHRT';
    if (missionHintRef.current) missionHintRef.current.textContent = telemetry.missionHint;
    if (missionProgressRef.current) missionProgressRef.current.style.transform = `scaleX(${telemetry.missionProgress})`;
  });

  return (
    <div className="hud-top">
      <div className="speedo">
        <b ref={speedRef}>0</b>
        <span>KM/H</span>
        <em className="gear" ref={gearRef}>
          N
        </em>
      </div>
      <div className="hud-top-right">
        <div className="wallet hud-wallet"><span>● {coins}</span><span>★ {stars}</span></div>
        <button
          type="button"
          className="btn btn-round"
          aria-label="Pause"
          onPointerDown={(e) => {
            e.preventDefault();
            onPause();
          }}
        >
          <span className="icon" aria-hidden="true">
            ⏸
          </span>
        </button>
      </div>
      <div className={`mission-chip${gameMode === 'parking' ? ' parking' : ''}`}>
        <strong ref={missionTitleRef}>FREIE FAHRT</strong>
        <span ref={missionHintRef}>FAHRE ZUM GRÜNEN STARTFELD</span>
        <i><b ref={missionProgressRef} /></i>
      </div>
    </div>
  );
}
